export default function (state = null, action) {
  switch (action.type) {
    case "CANCEL_REASONS":
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducer/get_cancel_resons.js